// extracted by mini-css-extract-plugin
export default {"container":"Brick_container__dzq9X","productListContainer":"Brick_productListContainer__R98Zx","productGrid":"Brick_productGrid__21kWm"};